import type { VerifiedFact } from "../types";

const presentationSource = {
  sourceTitle: "Social PPT — Project Overview",
  sourceType: "presentation" as const,
  sourceUrl: "/files/social-ppt-project-overview-en.pdf",
  sourceNote: "Англоязычная презентация проекта, апрель 2026 года.",
};

export const verifiedFacts: VerifiedFact[] = [
  {
    id: "annual-capacity",
    title: "Плановая мощность",
    value: "До 500 000 пациентов в год",
    shortDescription: "Плановая годовая пропускная способность центра.",
    category: "Мощность",
    status: "confirmed",
    publicUsage: "restricted",
    ...presentationSource,
    lastVerifiedAt: "2026-07-15",
    tags: ["пациенты", "год", "мощность", "capacity", "500000"],
  },
  {
    id: "construction-area",
    title: "Площадь объекта",
    value: "35 307,24 м² общей площади строительства",
    shortDescription: "В презентационных материалах также может использоваться округлённое значение 35 300 м².",
    category: "Инфраструктура",
    status: "confirmed",
    publicUsage: "allowed",
    ...presentationSource,
    lastVerifiedAt: "2026-07-15",
    tags: ["площадь", "строительство", "здание", "35300"],
  },
  {
    id: "usable-area",
    title: "Полезная площадь",
    value: "24 695,24 м²",
    category: "Инфраструктура",
    status: "confirmed",
    publicUsage: "allowed",
    ...presentationSource,
    lastVerifiedAt: "2026-07-15",
    tags: ["полезная площадь", "здание", "24695"],
  },
  {
    id: "site-area",
    title: "Территория с парковкой",
    value: "4,94 га",
    category: "Инфраструктура",
    status: "confirmed",
    publicUsage: "allowed",
    ...presentationSource,
    lastVerifiedAt: "2026-07-15",
    tags: ["территория", "парковка", "гектар"],
  },
  {
    id: "underground-parking",
    title: "Подземная парковка",
    value: "460 машиномест",
    category: "Инфраструктура",
    status: "confirmed",
    publicUsage: "allowed",
    ...presentationSource,
    lastVerifiedAt: "2026-07-15",
    tags: ["парковка", "автомобиль", "460"],
  },
  {
    id: "physicians",
    title: "Плановая команда врачей",
    value: "189 врачей",
    category: "Команда",
    status: "needs-review",
    publicUsage: "restricted",
    ...presentationSource,
    sourceNote: "Перед публичным использованием подтвердить актуальный штатный план.",
    lastVerifiedAt: "2026-07-15",
    tags: ["врачи", "команда", "штат", "189"],
  },
  {
    id: "medical-staff",
    title: "Плановая команда медицинских сотрудников",
    value: "158 медицинских сотрудников",
    category: "Команда",
    status: "needs-review",
    publicUsage: "restricted",
    ...presentationSource,
    sourceNote: "Перед публичным использованием подтвердить актуальный штатный план.",
    lastVerifiedAt: "2026-07-15",
    tags: ["медицинские сотрудники", "команда", "штат", "158"],
  },
  {
    id: "specialties",
    title: "Количество направлений",
    value: "Более 36 направлений первичной медицинской помощи",
    category: "Медицинские направления",
    status: "needs-review",
    publicUsage: "restricted",
    sourceTitle: "Рабочие материалы проекта",
    sourceType: "document",
    sourceNote: "Состав направлений и итоговое количество требуют дополнительной проверки.",
    lastVerifiedAt: "2026-07-15",
    tags: ["направления", "специальности", "36", "первичная помощь"],
  },
  {
    id: "location",
    title: "Местоположение",
    value: "Ташкент, Мирабадский район, МСГ «Тонг Юлдузи», улица Кучкуприк",
    category: "География",
    status: "needs-review",
    publicUsage: "restricted",
    sourceTitle: "Рабочие материалы проекта",
    sourceType: "document",
    sourceNote: "Требует проверки точного официального написания адреса.",
    lastVerifiedAt: "2026-07-15",
    tags: ["адрес", "Ташкент", "Мирабад", "Кучкуприк", "Тонг Юлдузи"],
  },
  {
    id: "care-model",
    title: "Модель оказания помощи",
    value: "Диагностическая и амбулаторная медицинская помощь",
    category: "Общая информация",
    status: "confirmed",
    publicUsage: "allowed",
    ...presentationSource,
    sourceNote: "Подтверждено на уровне позиционирования проекта.",
    lastVerifiedAt: "2026-07-15",
    tags: ["диагностика", "амбулаторная помощь", "модель"],
  },
  {
    id: "main-principle",
    title: "Главный принцип",
    value: "Люди прежде всего. Здоровье — не привилегия, а право.",
    category: "Общая информация",
    status: "confirmed",
    publicUsage: "allowed",
    ...presentationSource,
    lastVerifiedAt: "2026-07-15",
    tags: ["люди прежде всего", "право", "миссия"],
  },
  {
    id: "free-services",
    title: "Медицинские услуги",
    value: "В презентации проекта услуги для пациентов заявлены как бесплатные",
    fullDescription: "Не публиковать утверждение о бесплатных услугах без актуального подтверждения руководства проекта.",
    category: "Услуги",
    status: "needs-review",
    publicUsage: "internal-only",
    ...presentationSource,
    sourceNote: "Требует обязательного официального подтверждения перед публичным использованием.",
    lastVerifiedAt: "2026-07-15",
    tags: ["бесплатно", "услуги", "cost model", "free"],
  },
];
